/* eslint-disable max-len */
import classNames from 'classnames';
import React from 'react';

export const OpenBookIcon = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    <i className={classNames('bookriver-icon-OpenBookIcon', className)} {...props} />
  );
};
